import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="collapsible"
export default class extends Controller {
  static targets = ['content']
  static values = {
    open: {
      type: Boolean,
      default: false,
    },
  }

  connect() {
    // Set the initial state of the collapsible
    this.openValue ? this.open() : this.close()
  }

  // Toggle the 'open' value
  toggle() {
    this.openValue = !this.openValue
  }

  // Handle changes in the 'open' value
  openValueChanged(isOpen, wasOpen) {
    if (isOpen) {
      this.open()
    } else {
      this.close()
    }
  }

  // Open the collapsible content
  open() {
    if (this.hasContentTarget) {
      this.contentTarget.classList.remove('tw-hidden')
      this.openValue = true
    }
  }

  // Close the collapsible content
  close() {
    if (this.hasContentTarget) {
      this.contentTarget.classList.add('tw-hidden')
      this.openValue = false
    }
  }
}
